import { render, staticRenderFns } from "./pageModal.vue?vue&type=template&id=65868722&scoped=true"
import script from "./pageModal.vue?vue&type=script&lang=js"
export * from "./pageModal.vue?vue&type=script&lang=js"
import style0 from "./pageModal.vue?vue&type=style&index=0&id=65868722&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65868722",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65868722')) {
      api.createRecord('65868722', component.options)
    } else {
      api.reload('65868722', component.options)
    }
    module.hot.accept("./pageModal.vue?vue&type=template&id=65868722&scoped=true", function () {
      api.rerender('65868722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/mobilePreview/components/pageModal.vue"
export default component.exports